import { Component, useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { withFormik, Form } from "formik";

import { callSend, LocationSubsection, FormRow, PhoneRow, HeaderButtons, SelectRow } from "../../components/Form/Form";
import {
    validateOptionalRut, validateOptionalDV, validateEmail50, validateString50,
    validatePhone50, validateOptional50, validateOptional75, validateSomething
} from "../../components/Form/Validations";
import LoadingDialog from "../../components/Utils/LoadingDialog";

import withName from "../../hoc/withName";
import getBaseLangs from "../../utils/language";

import "react-toastify/dist/ReactToastify.css";
import "./../Personal/Personal.css";

import SelfHelp from "../../components/Utils/SelfHelp";
import { Message } from "primereact/message";

const formId = "personal_form";

class PersonalForm extends Component {
    constructor(props) {
        super(props);
        this.tipousuarioOptions = props.tipousuario && this.getOptions(props);
    }

    shouldComponentUpdate(nextProps) {
        if ((this.props.t !== nextProps.t) || (this.props.tipousuario !== nextProps.tipousuario)) {
            this.tipousuarioOptions = nextProps.tipousuario && this.getOptions(nextProps);
        }
        return true;
    }

    getOptions({ tipousuario, i18n }) {
        const lngs = getBaseLangs(i18n);
        return tipousuario.map((tu) => ({ value: tu.tipousuario_id, label: (tu.tipousuario[lngs[0]] || tu.tipousuario[lngs[1]]) }));
    }
    render() {
        const { resetForm, status = {}, setStatus, data, i18n, t, handleSubmit,
            alert, errors, hidden, msg, touched, values, isTableDialog, tableEdit, invite_email, user_invited } = this.props;
        if (!data && (!isTableDialog || hidden)) return <div className="card col"><div className="card-body altura-min" /></div>;
        const SelfHelpFarminfo1 = import.meta.glob("../../img/autoayuda/*/autoayuda-user-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-user-1.png`];
        const SelfHelpFarminfo2 = import.meta.glob("../../img/autoayuda/*/autoayuda-user-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-user-2.png`];

        return (
            <div className={isTableDialog ? "" : "card"}>
                <div className={isTableDialog ? "" : "card-body altura-min"}>
                    <Form id={formId} onSubmit={handleSubmit}>
                        {   user_invited?
                            <>
                                <div className='row'>
                                    <div className='col-12 text-center'>
                                        <Message
                                            style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                                            severity="success" text={t("invitationPage.inviteToast")}
                                        />
                                    </div>
                                </div>
                            </>
                            :null}
                        {
                            invite_email?
                                <>
                                    <div className='row'>
                                        <div className='col-12 text-center'>

                                            <p>{t("users.user_invite_1")} <b>{invite_email.email}</b> {t("users.user_invite_2")}</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 text-center'>

                                            <SelectRow edit nombre={`${t("users.tipousuario")} * `}
                                                campo="tipousuario_id"
                                                dataValue={data.tipousuario_id}
                                                defaultText="..."
                                                options={this.tipousuarioOptions}
                                                optionKey="value"
                                                optionLabel="label"
                                                placeholder="..."
                                                validate={validateSomething}
                                                error={touched.tipousuario_id && errors.tipousuario_id && t(errors.tipousuario_id)}
                                            />
                                        </div>
                                    </div>
                                </>
                                :!isTableDialog ?
                                    <>
                                        <div className='row'>
                                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                                <SelfHelp t={t} params={null} images={[SelfHelpFarminfo1, SelfHelpFarminfo2]} lng={i18n.language} />
                                            </div>
                                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                                <h5 className="card-title"><span>{t("personal.userInfo")}</span></h5>
                                            </div>
                                            <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                                                <HeaderButtons edit={status.edit} canEdit setStatus={setStatus} resetForm={resetForm} form={formId} />
                                            </div>
                                        </div>
                                        <div className='linea-titulo' />
                                    </>
                                    :(!data || !data.email) ?
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <FormRow
                                                    edit
                                                    nombre1={t("personal.email")}
                                                    campo1="email"
                                                    validate1={validateEmail50}
                                                    error1={touched.email && errors.email && t(errors.email)}
                                                    type1="email"
                                                />
                                                {alert ? <div className="alert alert-warning" role="alert">{t(alert)}</div> : null}
                                            </div>
                                        </div>
                                        :msg ?
                                            <div className="alert alert-info" role="alert">{t(msg)}</div>
                                            :null

                        }
                        {
                            !invite_email && !user_invited?
                                <div className='row'>
                                    <div className='col-12 text-center'>
                                        {(!isTableDialog || data) ? <>
                                            <FormRow edit={false} dato1={data.email} nombre1={t("personal.email")} campo1="email" />
                                            <FormRow
                                                edit={tableEdit || status.edit}
                                                dato1={data.nombre}
                                                nombre1={(tableEdit || status.edit) ? `${t("general.name")} *` : t("general.name")}
                                                campo1="nombre"
                                                validate1={validateString50}
                                                error1={touched.nombre && errors.nombre && t(errors.nombre)}
                                            />

                                            <FormRow
                                                edit={status.edit}
                                                dato1={data.apellido_paterno}
                                                nombre1={status.edit ? `${t("personal.fSurname")} *` : t("personal.fSurname")}
                                                campo1="apellido_paterno"
                                                validate1={validateString50}
                                                error1={touched.apellido_paterno && errors.apellido_paterno && t(errors.apellido_paterno)}
                                                dato2={data.apellido_materno}
                                                nombre2={t("personal.sSurname")}
                                                campo2="apellido_materno"
                                                validate2={validateOptional50}
                                                error2={touched.apellido_materno && errors.apellido_materno && t(errors.apellido_materno)}
                                            />

                                            <FormRow
                                                edit={tableEdit || status.edit}
                                                dato1={data.direccion}
                                                nombre1={t("personal.address")}
                                                campo1="direccion"
                                                validate1={validateOptional75}
                                                error1={touched.direccion && errors.direccion && t(errors.direccion)}
                                            />
                                        </> : null}

                                        {(!isTableDialog || (data && (tableEdit || status.edit))) ?
                                            <LocationSubsection t={t}
                                                validate={validateSomething} error={touched.pais && errors.pais && t(errors.pais)}
                                                edit={tableEdit || status.edit} language={i18n.language}
                                                ubicacion={data.ubicacion} pais={data.pais} validateForm={this?.props?.innerRef}
                                            />
                                            : null}

                                        {(!isTableDialog || (data && (!status.edit || values.pais))) ? <>
                                            {(status.edit && values.pais === "CL") || ((!status.edit || !values.pais) && data.pais === "CL") ?
                                                <FormRow
                                                    edit={status.edit}
                                                    dato1={data.rut} dato2={data.dv}
                                                    nombre1="RUT" nombre2=""
                                                    campo1="rut" campo2="dv"
                                                    validate1={validateOptionalRut} validate2={validateOptionalDV}
                                                    error1={touched.rut && errors.rut && t(errors.rut)} error2={touched.dv && errors.dv && t(errors.dv)}
                                                />
                                                :
                                                <FormRow edit={status.edit} dato1={data.pasaporte} nombre1={t("personal.pasaporte")} campo1="pasaporte"
                                                    validate1={validateOptional50} error1={touched.pasaporte && errors.pasaporte && t(errors.pasaporte)}
                                                />}

                                            <PhoneRow
                                                edit={tableEdit || status.edit}
                                                prefix={isTableDialog && values.prefix}
                                                dato1={data.telefono_movil}
                                                nombre1={t("personal.phone")}
                                                campo1="telefono_movil"
                                                error1={touched.telefono_movil && errors.telefono_movil && t(errors.telefono_movil)}
                                                dato2={data.telefono_fijo}
                                                nombre2={t("personal.fonoFijo")}
                                                campo2="telefono_fijo"
                                                error2={touched.telefono_fijo && errors.telefono_fijo && t(errors.telefono_fijo)}
                                            />
                                        </> : null}

                                        {isTableDialog && data ? (
                                            <SelectRow edit nombre={`${t("users.tipousuario")} * `}
                                                campo="tipousuario_id"
                                                dataValue={data.tipousuario_id}
                                                defaultText="..."
                                                options={this.tipousuarioOptions}
                                                optionKey="value"
                                                optionLabel="label"
                                                placeholder="..."
                                                validate={validateSomething}
                                                error={touched.tipousuario_id && errors.tipousuario_id && t(errors.tipousuario_id)}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                                :null
                        }
                    </Form>
                </div>
            </div>
        );
    }
}

const formValidate = ({ prefix, telefono_fijo, telefono_movil }) => {
    const errors = {};
    if (telefono_fijo) {
        const er = validatePhone50(prefix ? (prefix + telefono_fijo) : telefono_fijo);
        if (er !== undefined) errors.telefono_fijo = er;
    }
    if (telefono_movil) {
        const er = validatePhone50(prefix ? (prefix + telefono_movil) : telefono_movil);
        if (er !== undefined) errors.telefono_movil = er;
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = props.data || {};
        return {
            nombre: data.nombre,
            apellido_paterno: data.apellido_paterno,
            apellido_materno: data.apellido_materno,
            email: data.email,
            telefono_movil: data.telefono_movil,
            telefono_fijo: data.telefono_fijo,
            rut: data.rut,
            dv: data.dv,
            tipousuario_id: data.tipousuario_id,
            /* usuario_id: data.usuario_id, */
            prefix: undefined,
            pais: data.pais,
            ubicacion: data.ubicacion,
            direccion: data.direccion
        };
    },
    validate: formValidate,
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        if (!props.cancel) actions.setStatus({ edit: false });
    }
})(withTranslation()(PersonalForm));

const updateUserInfo = async (setInfo, newData, refreshUser) => {
    if (newData.data && newData.data.token) {
        try {
            await refreshUser(true);
        } catch (e) {
            console.error(e);
        }
    }
    setInfo(newData);
};

function Personal({ info, refreshUser, setInfo }) {
    const { t } = useTranslation();

    return (
        <div className='row-container'>
            {info.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className='col-12'>
                    <FormikForm
                        data={info.data}
                        updateData={(newData) => callSend("/personal", info.data, newData, t, (data) => updateUserInfo(setInfo, data, refreshUser), true)}
                    />
                </div>
            </div>
        </div>
    );
}

export { FormikForm as UserForm };
export default withName(Personal, "PersonalPage");
